package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.data.platform.CountryDetector
import com.eladfinish.bible.contest.platform.AppInfoProvider
import com.eladfinish.bible.contest.platform.WebAppInfoProvider
import com.eladfinish.bible.contest.platform.device.KeepScreenOnService
import com.eladfinish.bible.contest.platform.device.WebKeepScreenOnService
import com.eladfinish.bible.contest.platform.share.ShareTextFormatter
import com.eladfinish.bible.contest.screens.browse.usecases.CountPdfPagesUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.CountPdfPagesUseCaseImpl
import com.eladfinish.bible.contest.screens.browse.usecases.GenerateHtmlToPdfUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GenerateHtmlToPdfUseCaseImpl
import com.eladfinish.bible.contest.screens.browse.usecases.OpenPdfUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.OpenPdfUseCaseImpl
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SaveAsPdfUseCase
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SaveAsPdfUseCaseImpl
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SavePdfBytesUseCase
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SavePdfBytesUseCaseImpl
import org.koin.dsl.module

actual val platformModule = module {

    factory { CountryDetector() }

    single<KeepScreenOnService> { WebKeepScreenOnService() }

    single<AppInfoProvider> { WebAppInfoProvider() }

    single {
        ShareTextFormatter()
    }

    factory<SaveAsPdfUseCase> { SaveAsPdfUseCaseImpl(generateHtmlToPdfUseCase = get()) }

    factory<GenerateHtmlToPdfUseCase> { GenerateHtmlToPdfUseCaseImpl(generatePdfFromHtmlApiUseCase = get()) }

    factory<OpenPdfUseCase> { OpenPdfUseCaseImpl() }

    factory<CountPdfPagesUseCase> { CountPdfPagesUseCaseImpl() }

    factory<SavePdfBytesUseCase> { SavePdfBytesUseCaseImpl() }
}
